import Icon from '@/components/ui/AppIcon';

const steps = [
  {
    id: 'step_1',
    number: '01',
    title: 'Consultation',
    description:
      'We discuss your vision, location preferences, style inspiration, and specific requirements.',
    icon: 'ChatBubbleLeftRightIcon' as const,
  },
  {
    id: 'step_2',
    number: '02',
    title: 'Session',
    description:
      'Professional shoot with creative direction, ensuring every moment is captured perfectly.',
    icon: 'CameraIcon' as const,
  },
  {
    id: 'step_3',
    number: '03',
    title: 'Editing',
    description:
      'Expert post-processing and retouching to bring out the best in every image.',
    icon: 'SparklesIcon' as const,
  },
  {
    id: 'step_4',
    number: '04',
    title: 'Delivery',
    description:
      'Private gallery with download access, delivered within 2-3 weeks of the session.',
    icon: 'CloudArrowDownIcon' as const,
  },
]

export default function ProcessSection() {
  return (
    <section className="py-24 px-6 relative">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16 reveal">
          <h2 className="text-4xl md:text-6xl font-bold text-white mb-4 tracking-tight">
            How It Works
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            A simple, streamlined process from consultation to final delivery
          </p>
        </div>

        {/* Process Steps */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <div
              key={step.id}
              className="relative reveal"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              {/* Connector Line (hidden on last item) */}
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-12 left-full w-full h-px bg-gradient-to-r from-border to-transparent" />
              )}

              <div className="glass-panel rounded-2xl p-8 space-y-6 hover:bg-card transition-all duration-500 relative z-10">
                {/* Icon */}
                <div className="w-16 h-16 rounded-lg bg-white/10 flex items-center justify-center">
                  <Icon name={step.icon} size={32} className="text-white" />
                </div>

                {/* Number */}
                <div className="text-6xl font-bold text-white/10">
                  {step.number}
                </div>

                {/* Content */}
                <div className="space-y-2">
                  <h3 className="text-xl font-bold text-white">{step.title}</h3>
                  <p className="text-sm text-muted-foreground leading-relaxed">
                    {step.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}